<template>
  <div class="riskList">
    <div class="table-box">
      <div class="title flex justify-between">
        <div class="flex align-center">
          <div class="icon-box">
            <i class="iconfont icon-xingxing"></i>
          </div>
          <b>{{ total.title }}</b>
        </div>
        <div class="page-cancel" @click="$router.go(-1)">
          <i class="icon iconfont icon-jiantouzuo1"></i>返回
        </div>
      </div>
      <div class="total-container flex align-center justify-between margin-top-sm">
        <div class="item-total flex flex-direction">
          <div class="label">教培机构总数</div>
          <div class="total flex align-center">
            <div class="rate">{{ total.all_org }}</div>
          </div>
        </div>
        <div class="item-total red flex flex-direction">
          <div class="label">五星级机构数量</div>
          <div class="total flex align-center">
            <div class="number">{{ total.five_star.num }}</div>
            <div class="rate">{{ total.five_star.percent }}%</div>
          </div>
        </div>
        <div class="item-total purple flex flex-direction">
          <div class="label">四星级机构数量</div>
          <div class="total flex align-center">
            <div class="number">{{ total.four_star.num }}</div>
            <div class="rate">{{ total.four_star.percent }}%</div>
          </div>
        </div>
        <div class="item-total green flex flex-direction">
          <div class="label">三星级机构数量</div>
          <div class="total flex align-center">
            <div class="number">{{ total.three_star.num }}</div>
            <div class="rate">{{ total.three_star.percent }}%</div>
          </div>
        </div>
        <div class="item-total yellow flex flex-direction">
          <div class="label">二星级机构数量</div>
          <div class="total flex align-center">
            <div class="number">{{ total.two_star.num }}</div>
            <div class="rate">{{ total.two_star.percent }}%</div>
          </div>
        </div>
        <div class="item-total blue flex flex-direction">
          <div class="label">一星级机构数量</div>
          <div class="total flex align-center">
            <div class="number">{{ total.one_star.num }}</div>
            <div class="rate">{{ total.one_star.percent }}%</div>
          </div>
        </div>
      </div>
      <div class="search-flex">
        <div class="search-box">
          <el-form ref="form" :model="search" class="flex" label-width="100px">
            <el-form-item label="机构名称">
              <el-input v-model="search.keyword" placeholder="请输入机构名称搜索"></el-input>
            </el-form-item>
            <el-form-item label="是否预警">
              <el-select v-model="search.is_warning" :clearable="true" class="inp" placeholder="请选择">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="星级结果">
              <el-select v-model="search.star" :clearable="true" class="inp" placeholder="请选择">
                <el-option
                  v-for="item in evaluateResultOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分数范围">
              <div class="flex align-center">
                <el-input v-model="search.score_start" placeholder=""></el-input>
                <div class="margin-lr-xs">至</div>
                <el-input v-model="search.score_end" placeholder=""></el-input>
              </div>
            </el-form-item>
          </el-form>
          <div class="search-btn" @click="searchList">
            <i class="iconfont icon-sousuo"></i>搜索
          </div>
        </div>
      </div>
      <div class="list flex flex-direction">
        <el-table
          :cell-style="textCenter"
          :data="tableData"
          :header-cell-style="centerbgc"
          border
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            label="机构名称"
            prop="org_name"
            width="">
          </el-table-column>

          <el-table-column
            label="分数"
            prop="score"
            width="250">
          </el-table-column>
          <el-table-column
            label="是否预警"
            prop="star"
            width="250">
            <template slot-scope="scope">
              {{ scope.row.is_warning == 1 ? '是' : '否'}}
            </template>
          </el-table-column>
          <!--                        <el-table-column-->
          <!--                            label="排名"-->
          <!--                            prop="sort"-->
          <!--                            width="250">-->
          <!--                        </el-table-column>-->
          <el-table-column
            label="星级结果"
            prop="star"
            width="250">
            <template slot-scope="scope">
              {{ scope.row.star | star }}级
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="250">
            <template slot-scope="scope" class="flex">
              <el-link type="primary" @click="lookItem(scope.row)">查看报告</el-link>
              <el-link type="primary" class="margin-left-xs" @click="addItem(scope.row)">查看详情</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <el-pagination
            :current-page.sync="search.page"
            :page-size="search.limit"
            :total="search.total"
            background
            class="page-all margin-top self-end"
            layout="prev, pager, next"
            @current-change="list">
          </el-pagination>
        </div>
      </div>
    </div>
    <evaluateDialog
      :dialogVisible="dialogVisible"
      :id="id"
      :oid="itemid"
      @handleClose="handleClose" />
  </div>
</template>
<script>
import {getEvaluateOrgList, getEvaluationTotal} from "@/api/admin";
import {evaluateResultOptions,isYes} from "@/utils/const";
import {findByType} from "@/utils/utils";
import evaluateDialog from "@/views/admin/pages/orgDetail/common/evaluateDialog";
export default {
  name: "evaluate",
  data() {
    return {
      dialogVisible:false,
      oid: '',
      itemid: '',
      id: '',
      isYes:isYes,
      evaluateResultOptions: evaluateResultOptions,
      search: {
        status: '',
        is_warning: '',
        star: '',
        score_start: '',
        score_end: '',
        page: 1,
        limit: 10,
        total: 0,
      },
      tableData: [],
      loading: false,
      total: {
        all_org: 100,
        five_star: {num: 0, percent: 0},
        four_star: {num: 0, percent: 0},
        one_star: {num: 0, percent: 0},
        three_star: {num: 0, percent: 0},
        two_star: {num: 0, percent: 0},
      },
      cur_id: '',
      cur_type: false,
      addEvaluateDialog: false,
    }
  },
  components: {evaluateDialog},
  computed: {
    textCenter() {
      return {
        textAlign: 'center'
      }
    },
    centerbgc() {
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.id = this.$route.query.id
    this.$emit("setActive", {
      headActive: 3
    })
    this.init()
    this.list()
  },
  methods: {
    async init() {
      let _data = await getEvaluationTotal(this.id)
      this.total = _data.data
    },
    async list() {
      this.loading = true;
      let _data = await getEvaluateOrgList(
        this.id,
        this.search.keyword,
        this.search.is_warning,
        this.search.star,
        this.search.score_start,
        this.search.score_end,
        this.search.page,
        this.search.limit
      );
      this.loading = false;
      if (_data.status == 200) {
        this.tableData = _data.data.data
        this.search.total = _data.data.total
      } else {
        this.$message.error(_data.msg)
      }
    },
    searchList() {
      this.search.page = 1
      this.list()
    },
    reset() {
      this.search = {
        status: '',
        is_warning: '',
        star: '',
        score_start: '',
        score_end: '',
        page: 1,
        limit: 10,
        total: 0
      }
      this.list()
    },
    lookItem(row){
      // this.oid = row.org_id
      this.itemid = row.id
      this.dialogVisible = true
    },
    handleClose(){
      this.dialogVisible = false
    },
    addItem(item) {
      this.$router.push({
        path: '/admin/evaluateDetail',
        query: {
          oid: item.id,
          id: this.id
        }
      })
    }
  },
  watch: {},
  filters: {
    star(val) {
      return findByType(evaluateResultOptions, val)
    }
  }
}
</script>

<style lang="scss" scoped>
.riskList {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;

  .table-box {
    width: 100%;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    padding: 0 20px;
    border-radius: 10px;
    min-height: 500px;


    .title {
      display: flex;
      align-items: center;
      padding-top: 25px;
      padding-bottom: 25px;
      border-bottom: 2px solid #e3e7f0;

      b {
        font-size: 22px;
        color: #16181d;
        font-weight: bold;
        margin-left: 10px;
      }

      .icon-box {
        width: 30px;
        height: 30px;
        background-image: linear-gradient(-30deg,
          #3579fb 0%,
          #44a3ff 100%);
        box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
        border-radius: 10px;
        text-align: center;
        line-height: 30px;

        i {
          font-size: 20px;
          color: #ffffff;
        }
      }
    }

    .list {
      width: 100%;
      min-height: calc(100vh - (173px + 159px + 350px));
    }

    .total-container {
      .item-total {
        width: 285px;
        height: 112px;
        background-image: url("~@/assets/images/bg_star_total_1.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding: 25px;

        &.red {
          background-image: url("~@/assets/images/bg_star_total_2.png");

          .label {
            color: #f43d23;
          }

          .total {
            background-image: linear-gradient(66deg,
              #ffe9e9 0%,
              #ffffff00 80%);

            .number, .rate {
              color: #ff6853;
            }

            .number {
              border-right: 1px solid #ff685355;
            }
          }
        }

        &.purple {
          background-image: url("~@/assets/images/bg_star_total_3.png");

          .label {
            color: #7b3fff;
          }

          .total {
            background-image: linear-gradient(66deg,
              #f7f0ff 0%,
              #ffffff00 80%);

            .number, .rate {
              color: #7b3fff;
            }

            .number {
              border-right: 1px solid #7b3fff55;
            }
          }
        }

        &.green {
          background-image: url("~@/assets/images/bg_star_total_4.png");

          .label {
            color: #75c773;
          }

          .total {
            background-image: linear-gradient(66deg,
              #e9ffe9 0%,
              #ffffff00 80%);

            .number, .rate {
              color: #75c773;
            }

            .number {
              border-right: 1px solid #75c77355;
            }
          }

        }

        &.yellow {
          background-image: url("~@/assets/images/bg_star_total_5.png");

          .label {
            color: #ff9d32;
          }

          .total {
            background-image: linear-gradient(66deg,
              #fff4df 0%,
              #ffffff00 80%);

            .number, .rate {
              color: #ff9d32;
            }

            .number {
              border-right: 1px solid #ff9d3255;
            }
          }
        }

        &.blue {
          background-image: url("~@/assets/images/bg_star_total_6.png");
        }

        .label {
          font-size: 16px;
          color: #3e7bfa;
          opacity: 0.77;
        }

        .total {
          width: 238px;
          height: 31px;
          line-height: 31px;
          padding: 0 20px;
          background-image: linear-gradient(66deg,
            #e9f2ff 0%,
            #ffffff00 80%);
          border-radius: 16px;
          margin-top: 10px;

          .number, .rate {
            font-size: 22px;
            line-height: 22px;
            color: #3e7bfa;
          }

          .number {
            margin-right: 10px;
            padding-right: 10px;
            border-right: 1px solid #3e7bfa55;
          }
        }
      }
    }

    .search-flex {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 20px 0;

      .shensu {
        width: 163px;
        height: 37px;
        background-image: linear-gradient(0deg,
          #f59a23 0%,
          #feb555 100%);
        border-radius: 4px;
        text-align: center;
        line-height: 37px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;

        i {
          font-size: 20px;
          margin-right: 5px;
          color: #ffffff;
        }
      }

      .search-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .search-btn {
          width: 112px;
          height: 36px;
          background-image: linear-gradient(0deg,
            #2791ff 0%,
            #81b6ff 100%);
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          color: #ffffff;
          margin-left: 15px;
          cursor: pointer;

          i {
            font-size: 20px;
            margin-right: 5px;
            color: #ffffff;
          }

          &.reset {
            background-image: none;
            background-color: #ffffff;
            border-radius: 4px;
            border: solid 1px #cccccc;
            line-height: 34px;
            color: #333333;

            i {
              color: #999999;
            }
          }
        }
      }

    }
  }

}
</style>


